export const inserosale = {
  inesrosale_discrepancy_item_quantity_mismatch: `Item '{{0}} {{1}}' quantity '{{2}}' mismatch with DN '{{3}}' quantity '{{4}}'`,
};
